import { render, staticRenderFns } from "./RichText1.vue?vue&type=template&id=53232013&scoped=true"
import script from "./RichText1.vue?vue&type=script&lang=js"
export * from "./RichText1.vue?vue&type=script&lang=js"
import style0 from "./RichText1.vue?vue&type=style&index=0&id=53232013&prod&lang=less&scoped=true"
import style1 from "./RichText1.vue?vue&type=style&index=1&id=53232013&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53232013",
  null
  
)

export default component.exports